<template>
	<div class="page" v-if="page">
		<section class="section" v-if="!page.playoffs_active && page.position_chances">
			<div class="container content is-fullhd">
				<ChancesTablePositions v-if="page.position_chances.groups" :chances="page.position_chances" />
			</div>
		</section>

		<section class="section is-hidden-mobile" v-if="page.playoff_bracket">
			<div class="container is-fullhd">
				<Bracket
					v-if="page.playoff_bracket"
					:heading="page.playoffs_active ? 'Playoff Bracket' : 'Playoff Picture'"
					:bracket="page.playoff_bracket"
				/>
			</div>
		</section>

		<section class="section is-hidden-mobile" v-if="page.consolation_bracket">
			<div class="container is-fullhd">
				<Bracket
					v-if="page.consolation_bracket"
					:heading="page.playoffs_active ? 'Consolation Bracket' : 'Playoff Picture'"
					:bracket="page.consolation_bracket"
				/>
			</div>
		</section>

		<section class="is-hidden-tablet" v-if="page.playoff_bracket || page.consolation_bracket">
			<div class="container is-fullhd">
				<div class="tabs is-toggle is-fullwidth" v-if="page.playoff_bracket && page.consolation_bracket">
					<ul>
						<li :class="{ 'is-active': show_playoff_bracket }">
							<a @click.prevent="setPlayoffBracket">Playoffs</a>
						</li>
						<li :class="{ 'is-active': !show_playoff_bracket }">
							<a @click.prevent="setConsolationBracket">Consolation</a>
						</li>
					</ul>
				</div>

				<div :class="{ 'is-hidden': !show_playoff_bracket }">
					<Bracket :bracket="page.playoff_bracket" :is_playoffs="true" />
				</div>
				<div :class="{ 'is-hidden': show_playoff_bracket }">
					<Bracket :bracket="page.consolation_bracket" :is_playoffs="false" />
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Bracket from "@/components/Bracket"
import ChancesTablePositions from "@/components/ChancesTablePositions"

export default {
	components: {
		Bracket,
		ChancesTablePositions,
	},
	computed: {
		league() {
			return this.$store.getters.activeLeague
		},
		page() {
			return this.$store.getters.activePage
		},
		show_playoff_bracket() {
			return this.$store.getters.activePagePlayoffsBracket
		},
	},
	methods: {
		setPlayoffBracket() {
			this.$store.dispatch("setActivePagePlayoffsBracket", true)
		},
		setConsolationBracket() {
			this.$store.dispatch("setActivePagePlayoffsBracket", false)
		},
	},
	mounted() {
		this.$store.dispatch("setActivePage", "playoffs")
	},
}
</script>

<style>
.tabs {
	padding: 1rem;
}
</style>
